import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
const captureFeatures = ["Up to 10 active ideas", "Basic structuring framework", "7-day withering cycle", "Idea Garden view"];
const executeFeatures = ["Unlimited active ideas", "Full structuring framework", "Growth Instruments access", "AI-powered structuring", "Export to PDF, Markdown, JSON", "Idea revival", "Priority support"];
export function PricingSection() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const handleCaptureCta = () => {
    if (user) {
      navigate("/app");
    } else {
      navigate("/login");
    }
  };
  const handleExecuteCta = () => {
    if (user) {
      navigate("/app/profile");
    } else {
      navigate("/login");
    }
  };
  return <section id="pricing" className="py-16 md:py-24 px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-xl md:text-2xl font-medium text-foreground mb-3">
            Simple, honest pricing
          </h2>
          <p className="text-base text-muted-foreground">
            Start free. Upgrade when your ideas demand more.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Capture Plan */}
          <div className="bg-card border border-border rounded-2xl p-6 flex flex-col">
            <div className="mb-6">
              <h3 className="text-lg font-medium text-foreground">Dream</h3>
              <p className="text-sm text-muted-foreground mt-1">For exploring ideas</p>
            </div>

            <div className="mb-6">
              <span className="text-3xl font-medium text-foreground">Free</span>
            </div>

            <ul className="space-y-3 mb-8 flex-1">
              {captureFeatures.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-muted-foreground">
                  <Check className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                  <span>{feature}</span>
                </li>)}
            </ul>

            <Button onClick={handleCaptureCta} variant="outline" className="w-full rounded-lg py-5">
              Get Started
            </Button>
          </div>

          {/* Execute Plan */}
          <div className="bg-card border-2 border-primary rounded-2xl p-6 flex flex-col shadow-lg relative">
            <div className="absolute -top-3 left-6">
              <span className="bg-primary text-primary-foreground text-xs font-medium px-3 py-1 rounded-full">
                Most popular
              </span>
            </div>

            <div className="mb-6">
              <h3 className="text-lg font-medium text-foreground">Build</h3>
              <p className="text-sm text-muted-foreground mt-1">For serious founders</p>
            </div>

            <div className="mb-6">
              <span className="text-3xl font-medium text-foreground">$7.99</span>
              <span className="text-sm text-muted-foreground">/month</span>
            </div>

            <ul className="space-y-3 mb-8 flex-1">
              {executeFeatures.map(feature => <li key={feature} className="flex items-start gap-3 text-sm text-foreground">
                  <Check className="w-4 h-4 text-primary mt-0.5 flex-shrink-0" />
                  <span>{feature}</span>
                </li>)}
            </ul>

            <Button onClick={handleExecuteCta} className="w-full rounded-lg py-5">
              Upgrade to Execute
            </Button>
          </div>
        </div>
      </div>
    </section>;
}